import template from './social-auth.jade';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {
      login: '=',
      submiting: '=',
      socialSubmiting: '=',
      mergeData: '=',
      enterEmailData: '=',
    },
    controller(
      $rootScope,
      $scope,
      userService,
      apiService,
      remoteValidationService,
      analyticsService,
      popupService,
      authService,
    ) {
      'ngInject';

      this.authWindow = null;

      this.socialTypes = ['vk', 'fb', 'google', 'ok', 'mailru'];

      const sendClickAnalytics = type => {
        if (authService.isLastStepLogin) {
          analyticsService.socClick(type);
        } else {
          const parsedType = type === 'mailru' ? 'mail' : type;

          if (this.login) {
            analyticsService.socialAuth(parsedType);
          } else {
            analyticsService.socialRegister(parsedType);
          }
        }
      };

      const sendAuthAnalytics = (type, userCreated) => {
        if (authService.isLastStepLogin) {
          if (!userCreated) {
            analyticsService.successfulSocLogin(type);
          } else {
            analyticsService.successfulSocRegistration(type);
          }
        } else {
          const parsedType = type === 'mailru' ? 'mail' : type;

          if (!userCreated) {
            analyticsService.successSocialAuth(parsedType);
          } else {
            analyticsService.successSocialRegister(parsedType);
          }
        }
      };

      const initLogonMethods = rawType => {
        const type = rawType === 'mailru' ? 'mail' : rawType;

        window.socialLogOnStart = (socialLoginId, email, token, userCreated) => {
          const data = {
            socialLoginId,
            email,
            token,
          };
          this.socialSubmiting = true;
          apiService
            .socialLogin(data)
            .then(() => {
              sendAuthAnalytics(type, userCreated);

              return authService.getUserData();
            })
            .catch(() => {
              this.showError();
            })
            .finally(() => {
              this.socialSubmiting = false;
            });
        };

        window.showErrorSocialAuth = (socialType, errorType) => {
          const options = {};
          if (socialType) {
            options.socialType = socialType;
          }
          if (errorType) {
            options.errorType = errorType;
          }
          this.showError(options);
        };

        window.showNeedMergeEmailPopup = (mergeEmail, socialLoginId) => {
          this.mergeData = {
            visible: true,
            mergeEmail,
            socialLoginId,
            type,
            isLogin: this.login,
          };
          $scope.$apply(); // обновление данных в родительском методе не применяется без ручного apply
        };

        window.showNeedEmailPopup = (socialType, socialLoginId) => {
          this.enterEmailData = {
            visible: true,
            socialType,
            socialLoginId,
            type,
            isLogin: this.login,
          };
          $scope.$apply();
        };
      };

      const deleteLogonMethods = () => {
        delete window.socialLogOnStart;
        delete window.showErrorSocialAuth;
      };

      this.showError = options => {
        const popupData = options || {};
        popupService.openPopup('authError', { popupData });
      };

      this.openSocialAuth = type => {
        if (!this.submiting) {
          initLogonMethods(type);
          sendClickAnalytics(type);
          const popupWidth = 800;
          const popupHeight = 600;
          const popupTopPosition = (window.outerHeight - popupHeight) / 2;
          const popupLeftPosition = (window.outerWidth - popupWidth) / 2;
          const popupParams = `width=${popupWidth}, height=${popupHeight}, scrollbars=0, top=${popupTopPosition}, left=${popupLeftPosition}`;
          this.authWindow = window.open(`/auth/social-login/?type=${type}`, 'authForm', popupParams);
        }
      };

      this.closeAuth = () => {
        if (this.authWindow) {
          this.authWindow.close();
          deleteLogonMethods();
        }
      };

      $scope.$watch(
        () => this.authWindow && this.authWindow.closed,
        currentValue => {
          if (currentValue) {
            deleteLogonMethods();
          }
        },
      );

      $scope.$watch(
        () => this.submiting,
        currentValue => {
          if (currentValue) {
            this.closeAuth();
          }
        },
      );
    },
    controllerAs: 'socialAuthCtrl',
  };
};
